import {Component, Input, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'neo-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  @Input() errorCode: number;
  @Input() errorDescription: string;

  constructor(
    private router: Router,
    private preferenciasService: PreferenciasService
  ) {
    console.log('DEBUG PREFERENCIAS ERROR MODULE',this.preferenciasService.get('legal_email'));
   }

  ngOnInit(): void {
  }

  get paginaAterrizaje() {
    // return environment.pagina_aterrizaje;
    return environment.pagina_aterrizaje_front;
  }

  redireccion() {
    this.router.navigate([this.paginaAterrizaje]);
  }
}
